import React from 'react';
import classNames from 'classnames';
import { List } from 'immutable';

import {
  Image,
} from '@uncinc/uncinc-react-kitchen-sink';

import {
  Paragraph,
  View,
} from '@uncinc/react-drupal-core';
import i18next from '../../../../config/i18next';

import {
  Container,
  WysiwygField,
  Divider,
  Share,
} from '../../../../components';

import './style.scss';

const PartnerPageFull = ({ entity, className }) => {
  const classes = classNames(className);
  const id = entity.getIn(['nid', 0, 'value']);
  return (
    <article typeof="schema:WebPage" className={classes}>
      <div className="PartnerPageFull">
        <Container small>
          <h1 className="PartnerPageFull__title page-header">{entity.getIn(['title', 0, 'value'])}</h1>

          {entity.getIn(['body']).size > 0 && (
            <div className="PartnerPageFull__body">
              <WysiwygField
                property="schema:text"
                className="TextBlock"
                html={entity.getIn(['body', 0, 'processed'])}
              />
            </div>
          )}

          {entity.getIn(['field_image']).size > 0 && (
            <div className="PartnerPageFull__image__wrapper">
              <div className="PartnerPageFull__image">
                <Image
                  src={{
                    0: entity.getIn(['field_image', 0, 'styles', 'large']),
                    768: entity.getIn(['field_image', 0, 'styles', 'basic_image']),
                  }}
                  includeWebP
                />
              </div>
            </div>
          )}


          <div className="PartnerPageFull__paragraphs">
            {
              entity.getIn(['field_paragraphs'], List()).map((item, index) => {
                const paragraphId = item.get('target_id');
                const paragraph = item.getIn(['entity']);
                return (
                  <Paragraph key={paragraphId} entity={paragraph} id={paragraphId} containerless />
                );
              })
            }
            <Share title={i18next.t('share')} />
          </div>
        </Container>
        <Divider className="related-divider" />
        <View id="related_partners" display="block_1" args={[id]} />
      </div>
    </article>
  );
};

export default PartnerPageFull;
